import type { HtmlAttributesWithChildren } from '@studio/design-system/props';
import type { ReactElement } from 'react';
import { twMerge } from 'cn';

/** `<Drawer>` component. */
export const Drawer = ({
  children,
  className,
  ...props
}: HtmlAttributesWithChildren): ReactElement => (
  <div
    className={twMerge(
      'border-l border-base-100 transition-transform x-open:-translate-x-full',
      className
    )}
    {...props}
  >
    {children}
  </div>
);
